import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { Inspector } from 'react-inspector';
import { useFileReaderText } from "../../../../hooks";
import { ViewChunkPlainText } from "../text";
import { ViewerControlButtonDownload } from "../../controls/buttons";
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import { ViewArchiveInfoLoadingIcon } from "../../status";
import { InputRadioButtonList } from '@isyc-react/form/modules/input/option/radio';
import '@isyc-react/design/main';
import "./view-json.style.scss";

// TODO implement onViewed callback
// TODO remove inspector and use a better json viewer
export const ViewJson = props => {
  const {
    file,
    initExpandLevel = 1,
    onViewed
  } = props;
  const [loading, setLoading] = React.useState(true);
  const [json, setJson] = React.useState(undefined);
  const [view, setView] = React.useState({
    id: 'html',
    checked: true
  });
  const [error, setError] = React.useState(false);
  const [expandLevel, setExpandLevel] = React.useState(initExpandLevel);
  const {
    text
  } = useFileReaderText(file);
  React.useEffect(() => {
    if (text) {
      try {
        const parsed = JSON.parse(text);
        setJson(parsed);
      } catch (e) {
        // TODO error feedback alert fallback to plain text viewer
        setError(true);
        setView({
          id: 'plain',
          checked: true
        });
      }
      setLoading(false);
    }
  }, [text]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-json-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-json-tools"
  }, !error && /*#__PURE__*/React.createElement(InputRadioButtonList, {
    items: [{
      id: 'plain',
      checked: false
    }, {
      id: 'html',
      checked: true
    }],
    value: view,
    labels: ['Plain', 'JSON'],
    onChange: setView
  }), /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      file
    },
    name: file.name
  })), /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-json-document"
  }, loading ? /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: file.name
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, text && /*#__PURE__*/React.createElement(React.Fragment, null, view && view.id === 'plain' ? /*#__PURE__*/React.createElement(ViewChunkPlainText, {
    text: text,
    highlight: {
      enabled: true,
      languages: ['json']
    }
  }) : /*#__PURE__*/React.createElement(Inspector, {
    table: false,
    data: json,
    expandLevel: expandLevel
  }))))));
};